import Api from './api';

const PATH = '/llms';

const getLLM = async () => { 
  try {
    const response = await Api.get(`${PATH}`);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const getAllPaginate = async (page) => {
    try {
      const response = await Api.get(`${PATH}/paginate?page=${page}`);
      return response.data;
    } catch (err) {
      throw err;
    }
}
  
const getById = async (id) => {
    try {
      const response = await Api.get(`${PATH}/${id}`);
      return response.data;
    } catch (err) {
      throw err;
    }
}

const getAllEventDynamicsByLLM = async (id) => {
    try {
      const response = await Api.get(`${PATH}/get-all-event-dynamics/${id}`);
      return response.data;
    } catch (err) {
      throw err;
    }
}

const getListEventDynamicsByLLM = async (id) => {
    try {
      const response = await Api.get(`${PATH}/get-list-event-dynamic/${id}`);
      return response.data;
    } catch (err) {
      throw err;
    }
}

const getAllLLMTypes = async (page) => {
    try {
      const response = await Api.get(`${PATH}/get-all-llm-types`);
      return response.data;
    } catch (err) {
      throw err;
    }
}

const getLLMModels = async (input) => { 
    try {
      const response = await Api.post(`${PATH}/get-all-llm-models`, input);
      return response.data;
    } catch (err) {
      throw err;
    }
};

const verifyLLMConnection = async (input) => { 
    try {
      const response = await Api.post(`${PATH}/verify-llm-connection`, input);
      return response.data;
    } catch (err) {
      throw err;
    }
};

const create = async (input) => { 
  try {
    const response = await Api.post(PATH, input);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const addEventDynamic = async (input) => { 
  try {
    const response = await Api.post(`${PATH}/add-event-dynamic`, input);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const update = async (input) => { 
  try {
    const response = await Api.put(PATH, input);
    return response.data;
  } catch (err) {
    throw err;
  }
};

const deleteById = async (id) => {
  try {
    const response = await Api.delete(`${PATH}/${id}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

const deleteEventDynamicByLlmIdAndLlmEventId = async (llmId, llmEventId) => {
  try {
    const response = await Api.delete(`${PATH}/remove-event-dynamic/${llmId}/${llmEventId}`);
    return response.data;
  } catch (err) {
    throw err;
  }
}

export {
  getAllPaginate, 
  getById,
  getAllLLMTypes,
  getLLMModels,
  getLLM,
  create, 
  update,
  deleteById, 
  verifyLLMConnection,
  addEventDynamic,
  getAllEventDynamicsByLLM,
  deleteEventDynamicByLlmIdAndLlmEventId,
  getListEventDynamicsByLLM
};